import instance from 'utils/axios/instance.axios';
import { PROJECT_PROPOSALS_DEFENSE } from './_constant';

// eslint-disable-next-line import/prefer-default-export
export const getAll = (pagination, filters) => {
  const params = new URLSearchParams();

  // Add pagination params
  if (pagination) {
    if (pagination.first !== undefined) {
      params.append('first', pagination.first);
    }
    if (pagination.rowsPerPage !== undefined) {
      params.append('rowsPerPage', pagination.rowsPerPage);
    }
  }

  // Add filter params
  if (filters) {
    if (filters.vietnameseName) {
      params.append('vietnameseName', filters.vietnameseName);
    }
    if (filters.ownerName) {
      params.append('ownerName', filters.ownerName);
    }
    if (filters.councilTypes && filters.councilTypes.length > 0) {
      filters.councilTypes.forEach((code) => {
        params.append('councilTypes', code);
      });
    }
  }

  const url = params.toString()
    ? `${PROJECT_PROPOSALS_DEFENSE.GET_ALL}?${params.toString()}`
    : PROJECT_PROPOSALS_DEFENSE.GET_ALL;

  return instance.get(url);
};
